var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgGames(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.001 22.664a20.587 20.587 0 01-.438 4.246 1.505 1.505 0 01-1.874 1.118L27.69 23.363a3.33 3.33 0 01-2.406-3.197V3.51A1.512 1.512 0 0126.891 2a20.524 20.524 0 0110.667 3.978 20.295 20.295 0 012.987 2.679 20.6 20.6 0 015.456 14.007z",
    fill: "#6DA4F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.888 33.523a21.724 21.724 0 01-10.067 11.365 1.706 1.706 0 01-2.35-.85l-1.837-4.27-.7-1.624-4.462-10.41a1.035 1.035 0 011.25-1.405l10.823 3.122.625.175 5.625 1.636a1.7 1.7 0 011.093 2.26z",
    fill: "#FFAC59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.434 45.088a20.235 20.235 0 01-22.06-6.838c-.362-.45-.699-.912-1.018-1.386a20.236 20.236 0 015.496-27.932A20.27 20.27 0 0120.68 5.49a1.507 1.507 0 011.619 1.505v16.623c.001 1.381.286 2.748.837 4.015l6.424 14.956a1.765 1.765 0 01-1.125 2.498z",
    fill: "#73E673"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.298 6.995v14.782L6.375 38.25c-.363-.45-.7-.912-1.019-1.386a20.236 20.236 0 015.496-27.932A20.27 20.27 0 0120.68 5.49a1.507 1.507 0 011.619 1.505z",
    fill: "#8CFF8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.133 29.657l-8.199 8.487-4.462-10.41a1.035 1.035 0 011.25-1.405l10.823 3.122.588.206z",
    fill: "#FC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.558 5.978L25.266 18.704V3.511A1.512 1.512 0 0126.89 2a20.524 20.524 0 0110.668 3.978z",
    fill: "#8CBCFF"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h44v44H0z"
  })))));
}
export default SvgGames;